import React, { useEffect } from "react";
import DashboardSetup from "../../components/Dashboard";
import * as modalActions from "../../redux/actions/modalActions";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import * as serviceActions from "../../redux/actions/serviceAction";
import * as commonActions from "../../redux/actions/commonAction";
import * as loginActions from "../../redux/actions/loginActions";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import PropTypes from "prop-types";
import NotificationMarquee from "../../containers/Common/NotificationMarquee";

const Dashboard = (props, context) => {
  const serviceReducer = useSelector((state) => state.serviceReducer);
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const loginReducer = useSelector((state) => state.loginReducer);
  const notificationReducer = useSelector((state) => state.notification);
  const userAuthReducer = useSelector((state) => state.userAuthReducer);


  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  let serviceAction = bindActionCreators(serviceActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const userAuthAction = bindActionCreators(userAuthActions, dispatch);
  const loginAction = bindActionCreators(loginActions, dispatch);


  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const resetSelectedCompany = () => userAuthAction.resetSelectedCompany(null);

  const setOnLoginModalNotification = (isLoginModalNotification) => loginAction.resetOnLoginModalNotification(isLoginModalNotification);

  const getAuthUserRoles = (companyId) => userAuthAction.getAuthUserRoles(companyId);
  // Close modal component on change component
  useEffect(() => {
    return () => {
      closeRemoveModal();
    };
  }, []);

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}

      <div className="Content-Panel">
        <NotificationMarquee />
        <DashboardSetup
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          languageChange={languageChange}
          applicationCount={serviceReducer.managerApplicationCount}
          managersDetails={profileReducer.managersDetails}
          context={context}
          resetSelectedCompany={resetSelectedCompany}
          loginReducer={loginReducer}
          notificationReducer={notificationReducer}
          setOnLoginModalNotification={setOnLoginModalNotification}
          userAuthReducer={userAuthReducer}
          getAuthUserRoles={getAuthUserRoles}
        />
      </div>
    </>
  );
};

Dashboard.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default Dashboard;
